module.exports = __webpack_public_path__ + "img/file-dropzone.cc568d71.svg";